import {
    dropdownFieldConfigConstructor,
    percentRangeFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { DiscomfortLevelEnum, ProblemSeverityEnum } from "scenes/patient/anamnesis/enums";
import { MentalDiscomfortLevelEnum } from "scenes/patient/anamnesis/enums/MentalDiscomfortLevel.copy";

const problemSeverity = Object.values(ProblemSeverityEnum).map((value) => ({
    value,
    label: `anamnesis.quality.${value}`,
}));
const mentalProblemsSeverity = Object.values(MentalDiscomfortLevelEnum).map((value) => ({
    value,
    label: `anamnesis.quality.${value}`,
}));
const discomfortLevel = Object.values(DiscomfortLevelEnum).map((value) => ({
    value,
    label: `anamnesis.quality.${value}`,
}));

export const qualityOfLifeFields = {
    ...dropdownFieldConfigConstructor({
        category: Category.QUALITY_OF_LIFE,
        pathToValue: "anamnesis.anxiousValue",
        dropdownValues: mentalProblemsSeverity,
        label: "anamnesis.quality.anxiousOrDepressive",
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.QUALITY_OF_LIFE,
        pathToValue: "anamnesis.discomfortValue",
        dropdownValues: discomfortLevel,
        label: "anamnesis.quality.painOrDiscomfort",
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.QUALITY_OF_LIFE,
        pathToValue: "anamnesis.mobileValue",
        dropdownValues: problemSeverity,
        label: "anamnesis.quality.mobilityStatus",
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.QUALITY_OF_LIFE,
        pathToValue: "anamnesis.washAndDressValue",
        dropdownValues: problemSeverity,
        label: "anamnesis.quality.selfCareAbility",
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.QUALITY_OF_LIFE,
        pathToValue: "anamnesis.dailyActivityValue",
        dropdownValues: problemSeverity,
        label: "anamnesis.quality.dailyActivityValueShort",
    }),
    ...percentRangeFieldConstructor({
        label: "anamnesis.quality.scale",
        pathToValue: "anamnesis.scaleRateValue",
        category: Category.QUALITY_OF_LIFE,
    }),
};
